import { AvatarGroup, Button, UserPlus } from '@chain-zen/ui'

import type { UserDetails } from '../../types/user'

interface IMembersAvatarButton {
  buttonText: string
  members: UserDetails[]
  onClick: () => void
}

/**
 * This component is used to display the list of members in the shipment.
 * This component works as a popover trigger button.
 */
export const MembersAvatarButton = ({ buttonText, members, onClick }: IMembersAvatarButton) => {
  return (
    <Button onClick={onClick} variant="outline" className="h-9 w-full justify-start p-1 shadow-none hover:shadow-none">
      {members.length > 0 ? (
        <div className="flex items-center gap-2 px-2 py-1 w-full">
          <AvatarGroup
            people={members.map((member) => ({
              email: member.email,
              name: member.name ?? '',
              online: member.online,
              phone: member.phone,
              photo: member.photo ?? ''
            }))}
            max={3}
            size="xs"
            showTooltip={true}
            variant="basic"
            badgeColor="bg-green-500"
            badgeBoxSize="0.75em"
          />
          <span className="text-sm text-muted-foreground my-0 align-top truncate min-w-0">{`${members.length} member${
            members.length > 1 ? 's' : ''
          }`}</span>
        </div>
      ) : (
        <div className="flex items-center gap-2 px-2 w-full ml-0.5">
          <UserPlus className="h-4 w-4 shrink-0" />
          <span className="truncate min-w-0">{buttonText}</span>
        </div>
      )}
    </Button>
  )
}
